import {RefObject, useEffect} from "react";

/**
 * Calls the handler when the user clicks outside the given element.
 * Skips listening while disabled (e.g. during processing).
 */
export const useOutsideClick = (
    ref: RefObject<HTMLElement | null>,
    onOutsideClick: () => void,
    enabled: boolean
): void => {
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const handleMouseDown = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                onOutsideClick();
            }
        };
        document.addEventListener("mousedown", handleMouseDown);
        return () => document.removeEventListener("mousedown", handleMouseDown);
    }, [ref, onOutsideClick, enabled]);
};
